export const getReturnProtectionCountries = (returnProtection, regions) => {
  if (!returnProtection?.regions?.length) return []

  const regionIds = returnProtection.regions.map(region => region.region_id)

  return regions.filter(region => regionIds.includes(region.id))
}
